const ANONYMOUS_USER_ID_KEY = 'wegic_anonymous_user_id';
const ANONYMOUS_DEVICE_ID_COOKIE_NAME = 'anonymous-device-id';

function getBrowserLocalStorage(): Storage | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage ?? null;
  } catch {
    return null;
  }
}

function readStorageValue(read: (storage: Storage) => string | null): string | null {
  const storage = getBrowserLocalStorage();
  if (!storage) {
    return null;
  }

  try {
    return read(storage);
  } catch {
    return null;
  }
}

function runStorageOperation(operation: (storage: Storage) => void): void {
  const storage = getBrowserLocalStorage();
  if (!storage) {
    return;
  }

  try {
    operation(storage);
  } catch {
    // Browser privacy modes can throw on localStorage access.
  }
}

export function getAnonymousUserId(): string | null {
  return readStorageValue(storage => storage.getItem(ANONYMOUS_USER_ID_KEY));
}

export function setAnonymousUserId(userId: string): void {
  runStorageOperation(storage => storage.setItem(ANONYMOUS_USER_ID_KEY, userId));
}

export function clearAnonymousUserId(): void {
  runStorageOperation(storage => storage.removeItem(ANONYMOUS_USER_ID_KEY));
}

export function clearAnonymousDeviceIdCookie(): void {
  if (typeof document === 'undefined') {
    return;
  }

  try {
    document.cookie = `${ANONYMOUS_DEVICE_ID_COOKIE_NAME}=; Max-Age=0; Path=/; SameSite=Lax`;
  } catch {
    // Browser privacy modes can throw on cookie access.
  }
}
